<template>
  <div class="checkbox">
    <input type="checkbox" :id="id" :value="id" v-model="checkBoxValue" :disabled="disabled" @change="handleChecked" />
    <label :for="id">
      <p :class="{ bold: bold }" v-html="text" :style="{ fontSize: fontSize + 'px' }"></p>
    </label>
  </div>
</template>

<script>
export default {
  name: 'BtnCheckbox',
  props: {
    bold: Boolean,
    text: {
      type: String,
      default: 'name me',
    },
    value: String,
    id: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    fontSize: [String, Number]
  },
  data() {
    return {
      checkBoxValue: ''
    }
  },
  methods: {
    handleChecked() {
      this.checkBoxValue = this.id;
      this.$emit(this.id + 'Checked', this.checkBoxValue);
    }
  }
};
</script>

<style lang="scss" scoped>
.checkbox {
  display: flex;
  align-items: center;
  input[type='checkbox'] {
    display: none;
    & + label {
      display: inline-block;
      position: relative;
      padding-left: 21px;
      cursor: pointer;
      font-size: 16px;
      line-height: 1.3em;
      p {
        font-size: 16px;
      }
      /* height: 16px; */
      /* line-height: 1.24; */
      @media (hover: hover) {
        &:hover {
          opacity: 0.7;
        }
      }
      /* @media (max-width: $mobile) {
        font-size: 14px;
      } */
      &::before {
        content: '';
        position: absolute;
        top: 52%;
        top: 3px;
        /* transform: translateY(-50%); */
        left: 0;
        width: 16px;
        height: 16px;
        background-image: url('@/assets/icons/checkbox-off.svg');
        background-size: 16px 16px;
      }
    }
    &:checked {
      & + label {
        &::before {
          background-image: url('@/assets/icons/checkbox-on.svg');
        }
      }
    }
  }
}
</style>
